import type { SubjectValuesPayload } from '@Application/Subjects/Actions/subjectFetched';

export type SubjectAboutPayload = { kind: 'user' | 'staff' | 'facility'; id: number };

/** `about` is omitted from the body when the dossier is about nobody. */
class CreateSubject {
	constructor(
		public readonly facilityId: number,
		public readonly typeId: number,
		public readonly title: string,
		public readonly values: SubjectValuesPayload = {},
		public readonly about: SubjectAboutPayload | null = null,
	) {
		Object.freeze(this);
	}

	toJSON(): Record<string, unknown> {
		const body = { typeId: this.typeId, title: this.title, values: this.values };

		return this.about === null ? body : { ...body, about: this.about };
	}
}

export default CreateSubject;
